"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ErrorPage = ({ bannerText, values }) => (react_1.default.createElement(styles_1.ErrorPageContentWrapper, { icon: "!", type: "warning", "data-testid": "appointmentRescheduleErrorBanner" },
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, bannerText, { values: values }))));
exports.default = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map